import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const alertVariants = cva(
  "relative w-full rounded-lg border p-4 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:top-4 [&>svg]:left-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    defaultVariants: {
      variant: "default"
    },
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive:
          "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
        warn: "border-yellow-500 bg-yellow-200 text-foreground",
        "warn-secondary": "border-yellow-500 bg-yellow-100 text-foreground"
      }
    }
  }
);

const Alert: React.FC<
  React.ComponentProps<"div"> & VariantProps<typeof alertVariants>
> = ({ ref, className, variant, ...props }) => (
  <div
    className={cn(alertVariants({ variant }), className)}
    ref={ref}
    role="alert"
    {...props}
  />
);
Alert.displayName = "Alert";

const AlertTitle: React.FC<React.ComponentProps<"h5">> = ({
  ref,
  className,
  ...props
}) => (
  <h5
    className={cn("mb-1 font-medium leading-none tracking-tight", className)}
    ref={ref}
    {...props}
  />
);
AlertTitle.displayName = "AlertTitle";

const AlertDescription: React.FC<React.ComponentProps<"div">> = ({
  ref,
  className,
  ...props
}) => (
  <div
    className={cn("text-sm [&_p]:leading-relaxed", className)}
    ref={ref}
    {...props}
  />
);
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertDescription, AlertTitle };
